import { render } from "./waterReadings.vue?vue&type=template&id=9d81f108&scoped=true"
import script from "./waterReadings.vue?vue&type=script&lang=js"
export * from "./waterReadings.vue?vue&type=script&lang=js"

import "./waterReadings.vue?vue&type=style&index=0&id=9d81f108&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d81f108"]])

export default __exports__